// extracted by mini-css-extract-plugin
module.exports = {"formCheckInput":"styles_formCheckInput__2xIvH","formCheckLabel":"styles_formCheckLabel__3n_Tt"};